module.exports = __webpack_public_path__ + "media/images/icons/SVG/014-56fe6499a0dc39c008abba406f3865fb.svg";